// extracted by mini-css-extract-plugin
export default {"sortIcon":"app-react-components-datatables-TableHeaderSortIcons-module__sort-icon","activeSortIcon":"app-react-components-datatables-TableHeaderSortIcons-module__active-sort-icon"};